<template>

  <div class="mt-5 md:mt-0 md:col-span-2">
    <Mutation
      :mutation="mutation"
      :variables="variables"
      @done="onDone"
      @error="onError"
    >
      <template v-slot="{ mutate, loading }">
        <ValidationObserver
          ref="observer"
          tag="form"
          @submit.prevent="submit(mutate)"
        >
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-5 bg-white sm:p-6 grid grid-cols-3 gap-6">
              <div class="col-span-4 sm:col-span-3">
                <TextInput v-model="proposedCurrentPassword" name="current password" label="Old password" type="password" rules="required" />
              </div>
              <div class="col-span-4 sm:col-span-3">
                <TextInput v-model="proposedNewPassword" name="newPassword" label="New password" type="password" placeholder="At least 8 characters" rules="required|min:8|confirmed:confirm"/>
              </div>
              <div class="col-span-4 sm:col-span-3">
                <TextInput v-model="proposedNewPasswordConfirm" name="newPasswordConfirm" label="New password" rules="required|min:8|confirmed:confirm" type="password" placeholder="At least 8 characters" vid="confirm"/>
              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  tabindex="1"
                  class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-cardstock-green-600 hover:bg-cardstock-green-500 focus:outline-none focus:border-cardstock-green-700 focus:ring-cardstock-green active:bg-cardstock-green-700 transition duration-150 ease-in-out"

                  :disabled="loading"
                >
                  Save
                </button>
              </span>
            </div>
          </div>
        </ValidationObserver>
      </template>
    </Mutation>
  </div>
</template>

<script>
import Mutation from '@/components/Mutation.vue'
import TextInput from '@/components/TextInput.vue'

import CurrentUserPasswordChangeMutation from '@/mutations/CurrentUserPasswordChange.gql'

import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate";

export default {
  components: {
    Mutation,
    TextInput,
    ValidationObserver,
    ValidationProvider,
  },

  data() {
    return {
      mutation: CurrentUserPasswordChangeMutation,
      proposedCurrentPassword: '',
      proposedNewPassword: '',
      proposedNewPasswordConfirm: ''
    }
  },

  computed: {
    variables() {
      return {
        currentPassword: this.proposedCurrentPassword,
        newPassword: this.proposedNewPassword
      }
    }
  },

  methods: {
    onDone() {
      Bus.$emit('flash-message', {text: 'Password changed', type: 'success'})
      this.proposedCurrentPassword    = ''
      this.proposedNewPassword        = ''
      this.proposedNewPasswordConfirm = ''
      this.$refs.observer.reset()
    },

    onError(e) {
      Bus.$emit('flash-message', {text: e, type: 'error'})
      this.proposedCurrentPassword    = ''
      this.proposedNewPassword        = ''
      this.proposedNewPasswordConfirm = ''
      this.$refs.observer.reset()
    },

    async submit(mutate) {
      const isValid = await this.$refs.observer.validate()
      if (isValid) { mutate() }
    }
  }
}
</script>
